// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import type { CycleTimeMetric } from '@/report/api/types';
import { formatNumber } from '@/utilities/number';

const DAY_DIGITS = 1;
const EM_DASH = '—';

export const CYCLE_TIME_SMALL_SAMPLE_THRESHOLD = 10;

/**
 * A labeled cycle-time report segment keyed by the metric it reads from the
 * report. Segment definitions (labels, tooltips, colors) stay domain-owned.
 */
export interface CycleTimeSegment<K extends string = string> {
  key: K;
  label: string;
  tooltip: string;
  color: string;
}

export function emptyCycleTimeMetric(): CycleTimeMetric {
  return {
    p10Days: null,
    p25Days: null,
    medianDays: null,
    avgDays: null,
    p75Days: null,
    p90Days: null,
    count: 0,
  };
}

export function formatCycleTimeDays(value: number | null): string {
  if (value === null) {
    return EM_DASH;
  }

  const formattedValue = formatNumber(Math.abs(value), { digits: DAY_DIGITS });
  if (value < 0) {
    return `(${formattedValue}d)`;
  }

  return `${formattedValue}d`;
}

export function formatCycleTimeAxisDays(value: number): string {
  const formattedValue = formatNumber(Math.abs(value), { digits: DAY_DIGITS });
  const valueWithUnit = `${formattedValue} days`;
  if (value < 0) {
    return `(${valueWithUnit})`;
  }

  return valueWithUnit;
}
